import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const AcademicNav = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [value, setValue] = useState("/academic");
  const location = useLocation();

  const paths = [
    "/academic",
    "/academic/profiles",
    "/academic/curriculum",
    "/academic/topic-studied",
    "/academic/stage",
    "/academic/seminars",
    "/academic/seminar-attendances",
    "/academic/take-attendance",
    "/academic/assignments",
  ];

  useEffect(() => {
    const path = location.pathname;
    if (paths.includes(path)) {
      setValue(path);
    } else {
      setValue("/academic");
    }
  }, [location.pathname]);

  return (
    <Grid container sx={{ width: "100%", maxWidth: "100%", m: 0, flexDirection: "column" }}>
      <Box sx={{ width: "100%", flexShrink: 0, bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "100px" },
            }}
          >
            <Tab style={{ ...tabStyle, backgroundColor: value === "/academic" ? theme.palette.primary.main : "white", color: value === "/academic" ? "white" : "black" }} label={t("academic.dashboard", "Dashboard")} value="/academic" component={NavLink} to="/academic" />
            <Tab style={{ ...tabStyle, backgroundColor: value === "/academic/profiles" ? theme.palette.primary.main : "white", color: value === "/academic/profiles" ? "white" : "black" }} label={t("academic.profiles", "Profiles")} value="/academic/profiles" component={NavLink} to="/academic/profiles" />
            <Tab style={{ ...tabStyle, backgroundColor: value === "/academic/curriculum" ? theme.palette.primary.main : "white", color: value === "/academic/curriculum" ? "white" : "black" }} label={t("academic.curriculum", "Curriculum")} value="/academic/curriculum" component={NavLink} to="/academic/curriculum" />
            <Tab style={{ ...tabStyle, backgroundColor: value === "/academic/topic-studied" ? theme.palette.primary.main : "white", color: value === "/academic/topic-studied" ? "white" : "black" }} label={t("academic.topicStudied", "Topic studied")} value="/academic/topic-studied" component={NavLink} to="/academic/topic-studied" />
            <Tab style={{ ...tabStyle, backgroundColor: value === "/academic/stage" ? theme.palette.primary.main : "white", color: value === "/academic/stage" ? "white" : "black" }} label={t("academic.year7Stage", "Year 7 (Stage)")} value="/academic/stage" component={NavLink} to="/academic/stage" />
            <Tab style={{ ...tabStyle, backgroundColor: value === "/academic/seminars" ? theme.palette.primary.main : "white", color: value === "/academic/seminars" ? "white" : "black" }} label={t("academic.seminars", "Seminars")} value="/academic/seminars" component={NavLink} to="/academic/seminars" />
            <Tab style={{ ...tabStyle, backgroundColor: value === "/academic/seminar-attendances" ? theme.palette.primary.main : "white", color: value === "/academic/seminar-attendances" ? "white" : "black" }} label={t("academic.seminarAttendances", "Attendances")} value="/academic/seminar-attendances" component={NavLink} to="/academic/seminar-attendances" />
            <Tab style={{ ...tabStyle, backgroundColor: value === "/academic/take-attendance" ? theme.palette.primary.main : "white", color: value === "/academic/take-attendance" ? "white" : "black" }} label={t("academic.takeAttendance", "Take attendance")} value="/academic/take-attendance" component={NavLink} to="/academic/take-attendance" />
            <Tab style={{ ...tabStyle, backgroundColor: value === "/academic/assignments" ? theme.palette.primary.main : "white", color: value === "/academic/assignments" ? "white" : "black" }} label={t("academic.assignments", "Assignments")} value="/academic/assignments" component={NavLink} to="/academic/assignments" />
          </Tabs>
        </Paper>
      </Box>
      <Box component="main" sx={{ width: "100%", flex: 1, minWidth: 0, overflow: "auto" }}>
        <Outlet />
      </Box>
    </Grid>
  );
};

export default AcademicNav;
